@if(!selectedVehicle){
<a class="mobile-link" [class.disabled]="disabled" pRipple (click)="!disabled && openMobileBottomSheet()">
  <img src="./../../../../assets/images/icons/navigation/add-vehicle-mobile.svg" alt="add-vehicle">
  <span class="text">ADD VEHICLE</span>
</a>
} @else {
<a class="mobile-link" [class.disabled]="disabled" pRipple (click)="!disabled && openMobileBottomSheet()">
  <div class="car-img-wrapper">
    <img class="check-circle" src="./../../../../../assets/images/icons/check_circle.svg" alt="check-circle">
    <img class="car-icon" src="./../../../../assets/images/icons/navigation/add-vehicle-mobile.svg" alt="add-vehicle">
  </div>

  <span class="text selected-vehicle">{{selectedVehicle?.year}}
    {{selectedVehicle?.details?.manufacturer?.name}}
    {{selectedVehicle?.details?.model?.name}}
    {{selectedVehicle?.details?.modification?.name}}</span>
</a>
}
